// Library
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { asyncConnect } from 'redux-connect';
import ApplyCSS from '../../components/ApplyCSS';
// components
import Link from './../../components/ZUILib/Link';
/* import GRHeader from './../../components/GRHeader'; */
import Transition from './../../components/Transition';
import Tagging from '../../components/Tagging/Tagging';

// actions
import * as labelsActions from './../../components/labels/actions';
import * as masterPageActions from './page/EventData/MasterPage/actions';
// import * as contractPageActions from './page/EventData/ContractPage/actions';
import * as giftPreferencesActions from './page/EventData/GiftPreferences/actions';
import { getEventDetails } from './page/EventData/DatosDeMiEvento/actions';
import { loadEventCategoryEvent } from './../../components/eventcategory/actions';
// import * as weddingNewAddressActions from '../createEvent/components/GiftRegistryNewAddress/actions';
// import * as eCardDetailsActions from './page/EventData/CelebratedCard/actions';
import commonUtil from './../../utils/commonUtil';
import * as defaultConst from '../../utils/clientConstant';
import AppEvents from './../App/AppEvents';
// consts
const { eventManagmentConfig, eventManagmentConfigWAP, OPENING_GIFT, CLOSING_GIFT } = require('./eventManagementConfig');

const channel = commonUtil.getChannel().toUpperCase();
const pageName = 'eventManagement';
const { isLablesLoaded, loadLables } = labelsActions;
const { isMasterPageLoaded, loadMasterPage } = masterPageActions;
const applicationRoutes = commonUtil.getApplicationRoutes();
// const { isContractPageLoaded, loadContractPage } = contractPageActions;
// const { isWeddingNewAddLoaded, loadWeddingNewAdd } = weddingNewAddressActions;
// const { getdeliveryOptionOptedLoaded, getdeliveryOptionOpted, getdayNotApplicableLoaded, getdayNotApplicable } = giftPreferencesActions;
// const { loadeCardDetails } = eCardDetailsActions;

@asyncConnect([{
  deferred: false,
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
}, {
  deferred: false,
  promise: ({ store: { dispatch, getState } }) => {
    if (!isMasterPageLoaded(getState())) {
      return dispatch(loadMasterPage());
    }
    return undefined;
  },
},
])

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  // masterPage: store.masterPage.data,
  globleObj: store.globleObject,
}),
  {
    ...labelsActions,
    ...masterPageActions,
    ...giftPreferencesActions,
  })

class EventManagement extends Component {
  constructor(props) {
    super(props);
    this.activePage = 'DatosDeMiEvento';
    this.currentComponent = eventManagmentConfig.eventData[this.activePage];
    this.eventId = this.props.params.eventID ? this.props.params.eventID : '';
    this.profileId = (this.props.user && this.props.user.result && this.props.user.result.profileId) ? this.props.user.result.profileId : '';
    this.wapMenuRef = null;
    this.wapBackButtonEvent = null;
  }

  UNSAFE_componentWillMount = () => {
    if (channel === 'WAP') {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
    }
  }
  componentWillUnmount() {
    if (channel === 'WAP') {
      AppEvents.unsubscribe(this.wapMenuRef);
      AppEvents.unsubscribe(this.wapBackButtonEvent);
    }
  }
  componentWillReceiveProps(nextProps) {
    this.eventId = nextProps.params.eventID;
  }
  isArrayEmpty = obj => obj.length === 0
  /*eslint-disable */
  getCssClass = (index) => index === 0 && this.props.params.pageName === undefined ? 'active' : null
  /*eslint-enable */
  generateListOfEventInfo = () => {
    let eventType = null;
    let eventCategory = null;
    const EventDetails = this.props.userEventDetails;
    const giftAvailable = this.props.giftAvailable;
    if (EventDetails && EventDetails.eventDetailsInfo && EventDetails.eventDetailsInfo.eventType) {
      eventType = this.props.userEventDetails.eventDetailsInfo.eventType;
      eventCategory = this.props.userEventDetails.eventDetailsInfo.eventCategory;
    } else {
      return false;
    }
    const lists = [];
    if (eventManagmentConfig && eventManagmentConfig.eventData) {
      Object.keys(eventManagmentConfig.eventData).forEach((eventManagementPage, index) => {
        let eventDataURL = '';
        let linkData = {};

        if ((eventCategory === defaultConst.eventCategory.OPENEVENT && eventManagementPage !== OPENING_GIFT) ||
          (eventCategory !== defaultConst.eventCategory.OPENEVENT && eventManagementPage !== CLOSING_GIFT)) {
          if ((eventManagementPage === CLOSING_GIFT && !giftAvailable) ||
            (eventManagementPage === OPENING_GIFT && !giftAvailable)) {
            return;
          }
          if (eventManagementPage) {
            eventDataURL = commonUtil.getRouteByParameter(applicationRoutes.eventManagement, { pageName: eventManagementPage, eventID: this.eventId });
          }
          linkData = {
            route: eventDataURL,
            displayName: eventManagmentConfig.eventData[eventManagementPage].displayName,
          };
          lists.push(<li key={index}><Link
            rrLink={linkData}
            classname={eventManagementPage === this.props.params.pageName ? 'active' : this.getCssClass(index)}
          /></li>);
        }
        // return null;
      });
      this.updateGRHeaderProps([eventManagmentConfig, OPENING_GIFT, CLOSING_GIFT, eventType, eventCategory]);
      /* eslint-enable */
    }
    return lists;
  }
  componentDidMount() {
    const eventDetails = this.props.userEventDetails;
    if (!this.props.user) {
      browserHistory.push('/');
    }
    if (!commonUtil.isEmpty(eventDetails) && eventDetails.status.status === defaultConst.constAPIFailure) {
      browserHistory.push('/');
    }
    if (this.props.user &&
      this.props.user.result &&
      this.props.user.result.status.status === defaultConst.constAPIFailure) {
      browserHistory.push('/');
    }
    if (this.props.params && !this.props.params.eventID) {
      browserHistory.push('/');
    }
    // const eventId = this.props.params.eventID;
    // const profileId = this.props.user.result.profileId;
    this.profileId = (this.props.user && this.props.user.result && this.props.user.result.profileId) ? this.props.user.result.profileId : '';

    this.props.getEventDetails(this.eventId, this.profileId);
    this.props.loadEventCategoryEvent();
    if (channel === 'WAP') {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
      this.wapMenuRef = AppEvents.subscribe(AppEvents.EVENT_REGISTER.EVENT_MANEGEMENT_MENU_WAP);
      if (this.wapBackButtonEvent) {
        AppEvents.publish(this.wapBackButtonEvent, [this.showPreviousSection]);
      }
    }
    commonUtil.addTransition();

    const eventUrl = 'gestiondeeventos/DatosDeMiEvento/';

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: eventUrl,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Datos del evento',
      Site: 'Mesa de Regalos',
      idMesa: this.eventId,
    });
  }
  respectiveData = () => {
    if (typeof window !== 'undefined' && window && this.activePage) {
      // this.activePage = this.props.location && this.props.location.query && this.props.location.query.page ? this.props.location.query.page : this.activePage;
      this.activePage = this.props && this.props.params && this.props.params.pageName ? this.props.params.pageName : this.activePage;
      this.currentComponent = channel === defaultConst.constChannel.WEB ? eventManagmentConfig.eventData[this.activePage].component
        : eventManagmentConfigWAP.eventData[this.activePage].component;
      return this.currentComponent({ ...this.props });
    }
    return null;
    // this.currentComponent = channel === 'WEB' ? eventManagmentConfig.eventData[this.activePage].component : mobileEventManagmentConfig.eventData[this.activePage];
    // return this.currentComponent({ ...this.props });


    // TODO: logic to be implemented for loading component is happening for which module? e.g: eventManagment or myEvent....
  }
  updateGRHeaderProps = (eventManagmentMenuObjects) => {
    // AppEvents.publish('EVENT_MANEGEMENT_MENU_WAP', eventManagmentMenuObjects);
    AppEvents.publish(this.wapMenuRef, eventManagmentMenuObjects);
  }

  // add function for WAP event management
  showPreviousSection = () => {
    const menu = document.querySelector('.editEventName');
    const showCelebrityMenu = document.querySelector('.myEventContent.showCelebrity');
    const myEventsMenu = document.querySelector('.myEventsMenu');
    const innerWidth = window.innerWidth + 'px';
    if (menu && menu.style.left === '0px') {
      menu.style.left = innerWidth;
    } else if (showCelebrityMenu && showCelebrityMenu.style.left === '0px') {
      showCelebrityMenu.style.left = innerWidth;
    } else if (myEventsMenu && myEventsMenu.style.left === '0px') {
      myEventsMenu.style.left = innerWidth;
    } else {
      browserHistory.goBack();
    }
  }

  render() {
    const eventDetails = this.props.userEventDetails;
    const eventMenu = this.generateListOfEventInfo();
    return (
      <React.Fragment>
        {!commonUtil.isEmpty(eventDetails) && eventDetails.status.status !== defaultConst.constAPIFailure ?
          <div className={channel === 'WEB' ? 'container' : null}>
            {/* <GRHeader {...this.props} profileId={this.profileId} /> */}
            <ApplyCSS pageName={pageName} />
            <Transition eventId={this.eventId} />
            <Tagging ref={tagging => this.tagging = tagging} />
            {/* <div className="row myEventContainer"> */}
            <div className="myEventContainer">
              <div className="col-md-3">
                <ul className="myEventMenu">
                  {/* TODO: Hide the menu for suspended events in case of eventData */}
                  {channel === 'WEB' ? eventMenu : null}
                </ul>
              </div>
              {channel === 'WEB' ? <div className="col-md-9 closureContainer myWallets">
                {this.respectiveData()}
              </div> :
                this.respectiveData()
              }
            </div>
          </div>
          : null}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  lables: state.labels.data,
  notifications: state.notifications.data,
  user: state.user.data,
  userEventDetails: state.eventDetails.userEventDetails,
  giftAvailable: state.eventDetails && state.eventDetails.userEventDetails ? state.eventDetails.userEventDetails.giftAvailable : null,
});

const matchDispatchToProps = dispatch => bindActionCreators({ getEventDetails, loadEventCategoryEvent }, dispatch);

// export default connect(mapStateToProps, matchDispatchToProps)(EventManagement);
export default connect(mapStateToProps, matchDispatchToProps)(EventManagement);
